/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { eventType, IEcommUpcomingProgrammesProps } from './ecomm-upcoming-programmes.props.autogenerated';

import { getUpcomingEventsAsync, getUpcomingEventsByTypeAsync } from '../../actions/DataActionExtension.g';

import { IProgrammeCard } from './components/ecomm-programme-card';

import { IEcommUpcomingProgrammesData } from './ecomm-upcoming-programmes.data';
//import { IEcommUpcomingProgrammesProps } from './ecomm-upcoming-programmes.props.autogenerated';

import moment from 'moment';

export interface IEcommUpcomingProgrammesViewProps extends IEcommUpcomingProgrammesProps<IEcommUpcomingProgrammesData> {
    upcomingEvents: any[];
    existingMonths: string[];
    mobileEvents: { month: string; events: IProgrammeCard[] }[];
}

/**
 *
 * EcommUpcomingProgrammes component
 * @extends {React.PureComponent<IEcommUpcomingProgrammesProps<IEcommUpcomingProgrammesData>>}
 */
class EcommUpcomingProgrammes extends React.PureComponent<IEcommUpcomingProgrammesProps<IEcommUpcomingProgrammesData>> {
    public state = { upcomingEvents: [], existingMonths: [], mobileEvents: [] };

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public async componentDidMount() {
        const {
            data: { categories },
            config
        } = this.props;

        const startDate = new Date();
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date();
        endDate.setHours(0, 0, 0, 0);
        endDate.setMonth(endDate.getMonth() + config.dateRange);

        const language = this.props.context.request.locale.split('-')[0];

        const org = config.organisation ? this.props.config.organisation! : 'BT';
        const eventTypeOption = config.eventType ? config.eventType.toLowerCase() : eventType.all.toLowerCase();
        let eventTypeNo = '';

        if (eventTypeOption !== eventType.all.toLowerCase()) {
            switch (eventTypeOption) {
                case eventType.ceremony.toLowerCase():
                    eventTypeNo = '01';
                    break;

                case eventType.grouppractice.toLowerCase():
                    eventTypeNo = '02';
                    break;
            }
        }

        const data =
            eventTypeOption === eventType.all
                ? await getUpcomingEventsAsync(
                      { callerContext: this.props.context.actionContext },
                      config.isUat,
                      language,
                      org,
                      startDate.toISOString(),
                      endDate.toISOString()
                  )
                : await getUpcomingEventsByTypeAsync(
                      { callerContext: this.props.context.actionContext },
                      config.isUat,
                      language,
                      org,
                      eventTypeNo,
                      startDate.toISOString(),
                      endDate.toISOString()
                  );

        if (!categories.result) {
            await this.delay(300);
        }

        const events: any = [];
        const months: string[] = [];
        const mobileList: { month: string; events: IProgrammeCard[] }[] = [];

        data.map(event => {
            const eventJson = JSON.parse(event);

            if (eventJson['EcommerceId']) {
                var categoryIndex = categories.result!.findIndex(category => category.RecordId.toString() === eventJson['EcommerceId']);

                if (categoryIndex >= 0) {
                    var imgUrl = generateImageUrl(
                        categories.result![`${categoryIndex}`].Images![0].Uri,
                        this.props.context.request.apiSettings
                    );
                    eventJson['Img'] = imgUrl;
                }
            }

            eventJson['Redirect'] = config.redirectPortal ? config.portalUrl.destinationUrl : config.eventPdpUrl.destinationUrl;

            var programmeCard: IProgrammeCard = {
                id: eventJson['EcommerceId'],
                type: eventJson['Type'],
                name: eventJson['Name'],
                startDateTime: eventJson['StartDateTime'],
                endDateTime: eventJson['EndDateTime'],
                description: eventJson['Description'],
                img: eventJson['Img'],
                redirect: eventJson['Redirect'],
                portalRedirect: config.redirectPortal,
                callback: '',
                buttonText: config.cardButtonText,
                isDropdownVersion: config.displayMobileDropdown
            };

            events.push(programmeCard);

            const month = `${moment(new Date(programmeCard.startDateTime)).format('MMMM')}`;
            const index = months.findIndex(m => m === month);

            if (index === -1) {
                months.push(month);
            }
        });

        months.forEach(m => {
            const result = events.filter((item: IProgrammeCard) => `${moment(new Date(item.startDateTime)).format('MMMM')}` === m);

            mobileList.push({ month: m, events: result });
        });

        this.setState({
            upcomingEvents: events,
            existingMonths: months,
            mobileEvents: mobileList
        });
    }

    public render(): JSX.Element | null {
        const IEcommUpcomingProgrammesViewProps = {
            ...this.props,
            upcomingEvents: this.state['upcomingEvents'],
            existingMonths: this.state.existingMonths,
            mobileEvents: this.state.mobileEvents
        };

        return this.props.renderView(IEcommUpcomingProgrammesViewProps);
    }
}

export default EcommUpcomingProgrammes;
